import { SVGAttributes } from 'react';
import { Media, UnitValue } from '../../types';
import { tuple } from '../../utils';

export const srcIcons = tuple(
  'check',
  'question',
  'question-stroke',
  'preloader',
  'arrowLeft',
  'close',
  'close-m',
  'copy',
  'dropdown',
  'eye-open',
  'eye-closed',
  'calendar',
  'excel',
  'edit',
  'menu',
  'sorting',
  'agreement',
  'plus',
  'minus',
  'plus-thin',
  'minus-thin',
  'decline',
  'accept',
  'decline-m',
  'accept-m',
  'exchange',
  'history',
  'security',
  'passport',
  'support',
  'wallets',
  'logout',
  'login',
  'locker',
  'capture',
  'search',
  'arrow-down',
  'arrow-down-thin',
  'info',
  'info-m',
  'info-sign',
  'question-sign',
  'bank-card',
  'wire-transfer',
  'UT',
  'profile',
  'kyc',
  'filter',
  'share',
  'status-placed',
  'status-rejected',
  'status-part-filled',
  'arrow-right',
  'legend-graph-column',
  'legend-graph-wave',
  'trash',
  'exclamationMark',
  'visa',
  'mastercard',
  'order-ok',
  'order-alert',
  'warning',
  'gear',
  'apple',
  'telegram',
  'youtube',
  'utmedia',
  'twitter',
  'language-es',
  'language-en',
  'language-ru',
  'google-play',
  'mastercard-mini',
  'apple-pay',
  'google-pay',
  'bank',
  'card',
  'payeer',
  'utex',
  'utt',
  'main-acc'
);

export interface SvgEmotionProps {
  width?: UnitValue | Media<UnitValue>;
  height?: UnitValue | Media<UnitValue>;
  color?: string;
}

export interface IconSvgProps {
  src: typeof srcIcons[number];
}

export type SvgProps = SVGAttributes<HTMLOrSVGElement> | SvgEmotionProps;
